import { toRepositoryError } from '@/shared/repositories/common/repositoryError'

/**
 * Após refreshSession(), getUser() ainda pode falhar (corrida com logout, storage limpo).
 * Sempre mapeia para AppError UNAUTHORIZED para não vazar AuthSessionMissingError ao Sentry/UI.
 */
export async function resolveAuthUserAfterRefresh<T>(
  tryGetUser: () => Promise<T>,
  sessionErrorMessage: string,
): Promise<T> {
  try {
    return await tryGetUser()
  } catch (secondErr) {
    throw toRepositoryError(secondErr, sessionErrorMessage, 401)
  }
}
